import script from "./SimilarSearchDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimilarSearchDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SimilarSearchDialog.vue?vue&type=style&index=0&id=61d1ef96&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d1ef96"]])

export default __exports__